const exportStatus = {
    data: {
        CreatedDate: "2020-08-06T21:07:32.3370000Z",
        DevCommUserId: 260150,
        ErrorMessage: null,
        ExpireDate: "2020-09-05T21:11:13.7700000Z",
        Id: 615,
        LastModifiedDate: "2020-08-06T21:11:13.7700000Z",
        RequestSource: null,
        RequestType: 1,
        Status: 3,
        StatusText: "Completed",
        Vsid: "5c60d548-cca1-44a1-946f-38c42d538040",
        ZipFileTotalSizeInMb: 26.01,
        ZipFiles: [
            "archive-2020-08-06-e88ba548-a26b-4a01-8d3e-ecc065f21b31.zip",
            "archive-2020-08-06-e88ba548-a26b-4a01-8d3e-ecc065f21b31.zip"
        ]
    }
};

export default exportStatus;